var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfToWord = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 161,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9216_234)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.833 5.32308C142.132 3.94268 161.518 -3.41956 179.807 1.91346C199.063 7.52856 213.456 21.0381 224.973 35.1068C237.051 49.86 251.263 66.8263 247.333 84.3986C243.373 102.109 252.849 117.68 238.895 131.412C227.707 142.423 188.655 150.848 173.216 157.341C157.945 163.763 139.845 160.065 122.833 158.673C107.206 157.395 92.2834 154.685 77.8404 149.537C61.8904 143.852 46.5478 137.385 34.3056 127.121C19.5871 114.781 -1.99131 101.732 0.147587 84.3986C2.34911 66.5579 30.9027 60.5172 44.2568 46.4786C55.1526 35.0243 56.3879 17.4502 71.2232 9.67995C86.1291 1.87278 105.306 6.57666 122.833 5.32308Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 119.52V42.4796C32.5 40.2686 34.2382 38.5 36.3538 38.5H81.2713L99.4476 57.2014V119.52C99.4476 121.731 97.7094 123.5 95.5938 123.5H36.3538C34.2391 123.5 32.5 121.732 32.5 119.52Z",
    fill: "white",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4937,
    y: 95.5,
    width: 50.9602,
    height: 21,
    rx: 2.18571,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4937,
    y: 95.5,
    width: 50.9602,
    height: 21,
    rx: 2.18571,
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8882 110.476V101.524H57.9536C58.9468 101.524 59.7128 101.778 60.2515 102.286C60.7902 102.785 61.0595 103.484 61.0595 104.381C61.0595 105.278 60.7902 105.981 60.2515 106.489C59.7128 106.997 58.9468 107.251 57.9536 107.251H55.8452V110.476H53.8882ZM55.8452 105.727H57.6254C58.6607 105.727 59.1783 105.278 59.1783 104.381C59.1783 103.501 58.6607 103.06 57.6254 103.06H55.8452V105.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2724 110.476V101.524H65.757C67.2721 101.524 68.4463 101.913 69.2796 102.692C70.1129 103.463 70.5295 104.563 70.5295 105.994C70.5295 107.424 70.1129 108.529 69.2796 109.308C68.4463 110.087 67.2721 110.476 65.757 110.476H62.2724ZM64.2293 108.864H65.6434C67.5373 108.864 68.4842 107.907 68.4842 105.994C68.4842 104.089 67.5373 103.137 65.6434 103.137H64.2293V108.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0498 110.476V101.524H78.0596V103.06H74.0068V105.245H77.7818V106.781H74.0068V110.476H72.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2065 52.5996V39.236L98.8209 56.411H85.8772C83.8658 56.411 82.2065 54.7209 82.2065 52.5996Z",
    fill: "white",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 63.5H84C84.8284 63.5 85.5 64.1716 85.5 65V66C85.5 66.8284 84.8284 67.5 84 67.5H48C47.1716 67.5 46.5 66.8284 46.5 66V65C46.5 64.1716 47.1716 63.5 48 63.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 73.5H84C84.8284 73.5 85.5 74.1716 85.5 75V76C85.5 76.8284 84.8284 77.5 84 77.5H48C47.1716 77.5 46.5 76.8284 46.5 76V75C46.5 74.1716 47.1716 73.5 48 73.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 83.5H84C84.8284 83.5 85.5 84.1716 85.5 85V86C85.5 86.8284 84.8284 87.5 84 87.5H48C47.1716 87.5 46.5 86.8284 46.5 86V85C46.5 84.1716 47.1716 83.5 48 83.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.692 70.7745L133.538 76.0574C135.846 78.1436 137 79.1867 137 80.5305C137 81.8742 135.846 82.9173 133.538 85.0035L127.692 90.2865C126.639 91.2387 126.112 91.7149 125.678 91.5166C125.243 91.3182 125.243 90.6016 125.243 89.1682V85.6603C119.946 85.6603 114.207 88.2252 112 92.5C112 78.8205 119.848 75.4007 125.243 75.4007V71.8927C125.243 70.4594 125.243 69.7427 125.678 69.5444C126.112 69.3461 126.639 69.8222 127.692 70.7745Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 119.52V42.4796C149.5 40.2689 151.239 38.5 153.357 38.5H198.309L216.5 57.2015V119.52C216.5 121.731 214.76 123.5 212.643 123.5H153.357C151.24 123.5 149.5 121.732 149.5 119.52Z",
    fill: "white",
    stroke: "#192CD2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 94.5,
    width: 51,
    height: 21,
    rx: 2.18571,
    fill: "#192CD2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 94.5,
    width: 51,
    height: 21,
    rx: 2.18571,
    stroke: "#192CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.007 109L162.995 100.54H164.903L167.099 107.068H166.583L168.899 100.54H170.243L172.463 107.068H172.019L174.251 100.54H176.051L173.015 109H171.503L169.379 102.988H169.667L167.519 109H166.007ZM180.786 109.132C180.162 109.132 179.59 109.028 179.07 108.82C178.558 108.612 178.118 108.316 177.75 107.932C177.382 107.548 177.098 107.088 176.898 106.552C176.706 106.016 176.61 105.42 176.61 104.764C176.61 104.1 176.706 103.504 176.898 102.976C177.098 102.44 177.382 101.984 177.75 101.608C178.118 101.224 178.558 100.928 179.07 100.72C179.59 100.512 180.162 100.408 180.786 100.408C181.418 100.408 181.99 100.512 182.502 100.72C183.014 100.928 183.454 101.22 183.822 101.596C184.19 101.972 184.474 102.428 184.674 102.964C184.874 103.5 184.974 104.096 184.974 104.752C184.974 105.416 184.874 106.016 184.674 106.552C184.474 107.088 184.19 107.548 183.822 107.932C183.454 108.316 183.014 108.612 182.502 108.82C181.99 109.028 181.418 109.132 180.786 109.132ZM180.786 107.548C181.266 107.548 181.67 107.44 181.998 107.224C182.326 107 182.578 106.68 182.754 106.264C182.938 105.84 183.03 105.34 183.03 104.764C183.03 104.18 182.942 103.68 182.766 103.264C182.59 102.848 182.334 102.532 181.998 102.316C181.662 102.1 181.258 101.992 180.786 101.992C180.322 101.992 179.922 102.1 179.586 102.316C179.25 102.532 178.994 102.848 178.818 103.264C178.642 103.68 178.554 104.18 178.554 104.764C178.554 105.34 178.642 105.84 178.818 106.264C178.994 106.68 179.25 107 179.586 107.224C179.922 107.44 180.322 107.548 180.786 107.548ZM186.413 109V100.54H190.277C191.221 100.54 191.949 100.768 192.461 101.224C192.973 101.68 193.229 102.316 193.229 103.132C193.229 103.66 193.113 104.116 192.881 104.5C192.649 104.884 192.313 105.18 191.873 105.388C191.441 105.596 190.909 105.7 190.277 105.7L190.373 105.496H190.865C191.201 105.496 191.493 105.58 191.741 105.748C191.997 105.908 192.217 106.156 192.401 106.492L193.769 109H191.717L190.253 106.3C190.173 106.156 190.081 106.044 189.977 105.964C189.873 105.876 189.753 105.816 189.617 105.784C189.489 105.744 189.345 105.724 189.185 105.724H188.273V109H186.413ZM188.273 104.38H189.941C190.437 104.38 190.809 104.28 191.057 104.08C191.313 103.88 191.441 103.58 191.441 103.18C191.441 102.788 191.313 102.492 191.057 102.292C190.809 102.092 190.437 101.992 189.941 101.992H188.273V104.38ZM194.768 109V100.54H198.08C199.04 100.54 199.856 100.708 200.528 101.044C201.208 101.372 201.724 101.852 202.076 102.484C202.436 103.108 202.616 103.868 202.616 104.764C202.616 105.66 202.436 106.424 202.076 107.056C201.724 107.688 201.208 108.172 200.528 108.508C199.856 108.836 199.04 109 198.08 109H194.768ZM196.628 107.476H197.972C198.876 107.476 199.552 107.252 200 106.804C200.448 106.356 200.672 105.676 200.672 104.764C200.672 103.852 200.444 103.176 199.988 102.736C199.54 102.288 198.868 102.064 197.972 102.064H196.628V107.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.192 52.5996V39.2353L215.82 56.411H202.866C200.853 56.411 199.192 54.7205 199.192 52.5996Z",
    fill: "white",
    stroke: "#192CD2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.006 63H161C159.895 63 159 63.8954 159 65V67C159 68.1046 159.895 69 161 69H205.006C206.111 69 207.006 68.1046 207.006 67V65C207.006 63.8954 206.111 63 205.006 63Z",
    fill: "#192CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.006 73H161C159.895 73 159 73.8954 159 75V77C159 78.1046 159.895 79 161 79H205.006C206.111 79 207.006 78.1046 207.006 77V75C207.006 73.8954 206.111 73 205.006 73Z",
    fill: "#192CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.006 83H161C159.895 83 159 83.8954 159 85V87C159 88.1046 159.895 89 161 89H205.006C206.111 89 207.006 88.1046 207.006 87V85C207.006 83.8954 206.111 83 205.006 83Z",
    fill: "#192CD2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9216_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 161,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfToWord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf_to_word.ed597903f261e8eb277580f8c7d4a342.svg";